import React from "react";

const Telegram = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_164_670)">
      <path
        d="M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM14.793 6.32129C14.398 6.32827 13.7918 6.53918 10.876 7.75195C9.85458 8.1768 7.81353 9.05619 4.75293 10.3896C4.25596 10.5873 3.99538 10.7807 3.97168 10.9697C3.92666 11.3324 4.44916 11.4455 5.10645 11.6592C5.6424 11.8334 6.3633 12.0367 6.73828 12.0449C7.07825 12.0523 7.45805 11.9126 7.87695 11.625C10.7369 9.69445 12.214 8.7183 12.3066 8.69727C12.372 8.68244 12.4622 8.66429 12.5234 8.71875C12.5848 8.77334 12.5788 8.87658 12.5723 8.9043C12.5178 9.12783 9.83856 11.5651 9.67969 11.7295C9.08889 12.3431 8.41645 12.7192 9.45312 13.4023C10.3501 13.9934 10.8719 14.3709 11.7959 14.9766C12.3865 15.3637 12.8502 15.8227 13.46 15.7666C13.7405 15.7407 14.0306 15.4761 14.1777 14.6895C14.5256 12.8297 15.2092 8.80079 15.3672 7.14062C15.381 6.99524 15.3636 6.80925 15.3496 6.72754C15.3356 6.64589 15.3062 6.52953 15.2002 6.44336C15.0744 6.34128 14.8798 6.31976 14.793 6.32129Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_164_670">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Telegram.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Telegram;
